import React from "react";
import { Card, CardBody } from "reactstrap";
import "./WelcomeDashboard.css"; // Pastikan Anda membuat file CSS ini

const WelcomeDashboard = () => {
  return (
    <div>
      <Card className="welcome-card">
        <CardBody>
          <h1 className="welcome-title">Selamat Datang di Dashboard</h1>
          <p className="welcome-text">
            Kelola data pengguna dan pantau aktivitas dengan mudah. Silakan pilih menu di sidebar untuk mulai.
          </p>
        </CardBody>
      </Card>
    </div>
  );
};

export default WelcomeDashboard;
